import react from 'react';

const Article = (props = {}) => {
  let keys = Object.keys(props.categories);
  let oth = [];
  let loc = [];
  let attribute = props.attribute;
  if(keys.length > 0) {
    keys.map(key => {
      let item = props.categories[key];
      if(item.type == 'oth') {
        oth.push(item.title)
      } else if(item.type == 'loc'){
        loc.push(item.title)
      };
    });
  }

//  oth = oth.join('、');
  loc = loc.join('、');

  if(oth === '' || oth === null) oth = '-';
  if(loc === '' || loc === null) loc = '-';

  const CategoryTags = attribute.split(',').map((tag) => {
    return (<span class="c-tag -blue -size_MM -circle -entry" key="{tag}">{tag}</span>);
  });

  const JobTypes = oth.map((val) => {
    return (<li><span class="c-tag -size_MM -circle -entry -line">{val}</span></li>);
  });

  return (
    <>
      <a class="p-panel-recruit" href={props.link}>
        <div class="p-panel-recruit__category">
          {CategoryTags}
        </div>
        <div class="p-panel-recruit__type"><i class="i-arrow-icon -blue_outline -size_L"></i>
          <div class="p-panel-recruit__type-label">
            <p class="c-sentence  -black -size_20_18 -bold -entry">{props.title}</p>
          </div>
        </div>
        <div class="p-panel-recruit__location">
          <div class="p-panel-recruit__location-label"><i class="i-pin-icon -size_S -black"></i>
          </div>
          <div class="p-panel-recruit__location-content">
            <p class="c-sentence  -black -size_14 -bold">{loc}</p>
          </div>
        </div>
        <div class="p-panel-recruit__type-detail">
          <ul class="p-panel-recruit__detail-list">
            {JobTypes}
          </ul>
        </div>
      </a>
    </>
  )
}

export default Article;